import { render, staticRenderFns } from "./repairRecord.vue?vue&type=template&id=12e61bd3&scoped=true"
import script from "./repairRecord.vue?vue&type=script&lang=js"
export * from "./repairRecord.vue?vue&type=script&lang=js"
import style0 from "./repairRecord.vue?vue&type=style&index=0&id=12e61bd3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e61bd3",
  null
  
)

export default component.exports